export default __webpack_public_path__ + "static/media/2-10_icon.a6fb17ef.svg";